import React, { useEffect, useRef } from "react";
import "./ResultScreen.css";

export default function ResultScreen({ status }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    let stopConfetti;
    if (status === "success") {
      stopConfetti = startConfetti(canvasRef.current);
    }
    return () => {
      if (stopConfetti) {
        stopConfetti();
      }
    };
  }, [status]);

  return (
    <div className={`result-screen ${status}`}>
      {status === "success" ? (
        <>
          <canvas ref={canvasRef} className="confetti"></canvas>
          <h1 className="title">Success 🎉</h1>
          <p className="message">Payment Successful!</p>
        </>
      ) : status === "failed" ? (
        <>
          <div className="shake"></div>
          <h1 className="title failed">Failed 💀</h1>
          <p className="message">Payment Failed.</p>
        </>
      ) : null}
    </div>
  );
}

// Confetti animation logic (simple and pure JS)
function startConfetti(canvas) {
  if (!canvas) return () => {};
  const ctx = canvas.getContext("2d");
  const confettis = [];
  const colors = ["#FF6B6B", "#FFD93D", "#6BCB77", "#4D96FF"];

  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;

  for (let i = 0; i < 150; i++) {
    confettis.push({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height - canvas.height,
      r: Math.random() * 6 + 2,
      color: colors[Math.floor(Math.random() * colors.length)],
      speed: Math.random() * 3 + 2,
    });
  }

  let animationFrameId;
  const draw = () => {
    if (!ctx) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    confettis.forEach((c) => {
      ctx.beginPath();
      ctx.arc(c.x, c.y, c.r, 0, 2 * Math.PI);
      ctx.fillStyle = c.color;
      ctx.fill();
      c.y += c.speed;
      if (c.y > canvas.height) {
        c.y = 0 - c.r;
        c.x = Math.random() * canvas.width;
      }
    });
    animationFrameId = requestAnimationFrame(draw);
  };
  draw();

  return () => {
    cancelAnimationFrame(animationFrameId);
  };
}
